import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";

const servicesLinks = [
  { to: "/auto", label: "Seguro Auto" },
  { to: "/saude", label: "Planos de Saúde" },
  { to: "/agricola", label: "Seguro Agrícola" },
  { to: "/previdencia", label: "Previdência Privada" },
  { to: "/vida", label: "Seguro de Vida" },
  { to: "/consorcio", label: "Consórcio" },
];

// Submenu como componente separado para reutilizar
const ServicesDropdown = ({ isOpen }) => {
  return (
    <div
      className={`
        absolute left-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50
        transform transition-all duration-200 origin-top
        ${
          isOpen
            ? "opacity-100 scale-100"
            : "opacity-0 scale-95 pointer-events-none"
        }
      `}
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="services-menu"
    >
      <div className="py-1">
        {servicesLinks.map(({ to, label }) => (
          <Link
            key={to}
            to={to}
            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none"
            role="menuitem"
            tabIndex={isOpen ? 0 : -1}
          >
            {label}
          </Link>
        ))}
      </div>
    </div>
  );
};

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const dropdownTimeoutRef = useRef(null);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const toggleServicesDropdownMobile = () => {
    setServicesDropdownOpen(!servicesDropdownOpen);
  };

  const handleMouseEnter = () => {
    clearTimeout(dropdownTimeoutRef.current);
    setServicesDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    dropdownTimeoutRef.current = setTimeout(() => {
      setServicesDropdownOpen(false);
    }, 200);
  };

  // Handle keyboard events for accessibility
  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      setServicesDropdownOpen(false);
    }
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setServicesDropdownOpen((prev) => !prev);
    }
  };

  return (
    <header className="absolute top-0 left-0 w-full z-50 bg-white/20 backdrop-blur-md text-white transition-colors duration-300">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <Link to="/" className="flex items-center">
          <img
            src={require("../../assets/images/logofree.png")}
            alt="Free Market Seguros"
            className="h-8"
          />
        </Link>

        {/* Menu Desktop */}
        <nav
          className="hidden md:flex space-x-8 items-center relative"
          aria-label="Main navigation"
        >
          <Link
            to="/sobre"
            className="hover:text-orange-300 transition font-medium"
          >
            Sobre
          </Link>

          <div
            className="relative"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <button
              id="services-menu"
              aria-haspopup="true"
              aria-expanded={servicesDropdownOpen}
              onKeyDown={handleKeyDown}
              onClick={() => setServicesDropdownOpen((prev) => !prev)}
              className="hover:text-orange-300 transition flex items-center font-medium focus:outline-none focus:ring-2 focus:ring-orange-400 rounded"
            >
              Serviços 
              <i
                className="fas fa-chevron-down ml-1 text-xs"
                aria-hidden="true"
              />
            </button>

            <ServicesDropdown isOpen={servicesDropdownOpen} />
          </div>

          <Link
            to="/blog"
            className="hover:text-orange-300 transition font-medium"
          >
            Blog
          </Link>
          <Link
            to="/contato"
            className="hover:text-orange-300 transition font-medium"
          >
            Contato
          </Link>
        </nav>

        {/* Botões Direita */}
        <div className="flex items-center space-x-4">
          <Link
            to="/simulacao"
            className="bg-orange-500 hover:bg-orange-600 text-white px-2 md:px-3 lg:px-6 py-2 md:py-2 lg:py-3 rounded-lg font-medium hidden md:inline-flex items-center gap-1 text-sm md:text-base"
          >
            <i className="fas fa-car" />
            <span className="hidden lg:inline"> Simular Agora</span>
          </Link>
          <button
            className="md:hidden text-white focus:outline-none focus:ring-2 focus:ring-orange-400 rounded"
            onClick={toggleMobileMenu}
            aria-label="Abrir menu móvel"
            aria-expanded={mobileMenuOpen}
          >
            <i className="fas fa-bars text-2xl" />
          </button>
        </div>
      </div>

      {/* Menu Mobile */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-blue-950/40 shadow-inner">
          <div
            className="px-4 pt-4 pb-6 space-y-2"
            role="menu"
            aria-label="Menu móvel"
          >
            <Link
              to="/sobre"
              className="block px-3 py-2 text-white hover:bg-blue-700 rounded-md font-medium"
              role="menuitem"
              tabIndex={0}
              onClick={() => setMobileMenuOpen(false)}
            >
              Sobre
            </Link>

            {/* Mobile Dropdown */}
            <div>
              <button
                onClick={toggleServicesDropdownMobile}
                className="w-full flex justify-between items-center px-3 py-2 text-white hover:bg-blue-950 rounded-md font-medium focus:outline-none focus:ring-2 focus:ring-orange-400"
                aria-haspopup="true"
                aria-expanded={servicesDropdownOpen}
              >
                Serviços 
                <i
                  className={`fas fa-chevron-${
                    servicesDropdownOpen ? "up" : "down"
                  } text-xs`}
                  aria-hidden="true"
                />
              </button>
              {servicesDropdownOpen && (
                <div
                  className="pl-4 mt-2 space-y-1"
                  role="menu"
                  aria-label="Submenu Nossos Serviços"
                >
                  {servicesLinks.map(({ to, label }) => (
                    <Link
                      key={to}
                      to={to}
                      className="block px-3 py-2 text-white hover:bg-blue-700 rounded-md font-medium"
                      role="menuitem"
                      tabIndex={0}
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      {label}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/blog"
              className="block px-3 py-2 text-white hover:bg-blue-700 rounded-md font-medium"
              role="menuitem"
              tabIndex={0}
              onClick={() => setMobileMenuOpen(false)}
            >
              Blog
            </Link>
            <Link
              to="/contato"
              className="block px-3 py-2 text-white hover:bg-blue-700 rounded-md font-medium"
              role="menuitem"
              tabIndex={0}
              onClick={() => setMobileMenuOpen(false)}
            >
              Contato
            </Link>

            <Link
              to="/simulacao"
              className="inline-block px-3 py-2 bg-orange-500 text-white hover:bg-orange-600 rounded-md mt-4 font-medium text-left"
              role="menuitem"
              tabIndex={0}
              onClick={() => setMobileMenuOpen(false)}
            >
              Simular Agora
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
